export function TestModeBanner({ printOptIn }: { printOptIn?: boolean }) {
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999, background: '#b45309', color: '#fff', textAlign: 'center', padding: '4px', fontSize: 12 }}>
      TEST MODE — comped (no charge){printOptIn ? ' · real print ON' : ' · print OFF'}
    </div>
  );
}
